import { SubmissionError } from 'redux-form'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { translate } from 'loankeeper-common/helpers'
import { destroy as destroyFetcher } from 'loankeeper-common/helpers/SimpleFetchManager'

import { Order } from '../../../WebAPI'
import { actions as LKModalActions } from '../../shared/LKModal'

import { searchAccounts } from '../helpers'

const translateLKMessage = (key) => translate(`LKMESSAGE-${key}`)

export const validate = (values) => {
  const errors = {}

  if (!values.DebitAccID) {
    errors.DebitAccNo = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
  }

  if (!values.CreditAccID) {
    errors.CreditAccNo = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
  }

  if (!values.Amount) {
    errors.Amount = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
  }

  if (!values.DocDate) {
    errors.DocDate = translate('LKMESSAGE-ERR_REQUIRED_FIELD_DATE')
  }

  if (values.DocDate && !LKDate.isValid(values.DocDate)) {
    errors.DocDate = translate('LKMESSAGE-ERR_REQUIRED_FIELD_DATE')
  }

  if (values.Amount > 100000000) {
    errors.Amount = `${translate('LKMESSAGE-HINT_PROD_MAX')}100000000`
  }

  return errors
}

//NOT USED ANYWHERE
export const onSubmit = (values, dispatch, ownProps) => {
  const accountsToCheck = [
    {
      dispatch,
      accountID: values.DebitAccNo,
      name: 'DebitAccNo',
      fetcherName: ownProps.checkDebitAccountFetcherName,
    },

    {
      dispatch,
      accountID: values.CreditAccNo,
      name: 'CreditAccNo',
      fetcherName: ownProps.checkCreditAccountFetcherName,
    },
  ]

  return Promise.all(accountsToCheck.map((accounts) => searchAccounts(accounts)))
    .then((data) => {
      const debitAccounts = data[0].Data
      const creditAccounts = data[1].Data

      const submissionErrors = {}

      if (debitAccounts.length !== 1) {
        ownProps.change('DebitAccID', '')
        ownProps.change('DebitAccHash', '')
        ownProps.change('DebitTitleUNI', '')

        submissionErrors.DebitAccNo = 'Invalid'
      }

      if (creditAccounts.length !== 1) {
        ownProps.change('CreditAccID', '')
        ownProps.change('CreditAccHash', '')
        ownProps.change('CreditTitleUNI', '')

        submissionErrors.CreditAccNo = 'Invalid'
      }

      if (Object.keys(submissionErrors).length) {
        throw new SubmissionError(submissionErrors)
      }

      return {
        debitAccount: debitAccounts[0],
        creditAccount: creditAccounts[0],
      }
    })
    .then((data) => {
      const apiArgs = {
        ...values,
        PersonalNo: values.CardNumber,
        OperTypeID: ownProps.OperTypeID,
        DebitAccID: data.debitAccount.ID,
        HashSum_DebitAccID_: data.debitAccount.HashSum_AccountID_,
        CreditAccID: data.creditAccount.ID,
        HashSum_CreditAccID_: data.creditAccount.HashSum_AccountID_,
      }

      delete apiArgs.CCY
      delete apiArgs.DebitAccNo
      delete apiArgs.DebitTitleUNI
      delete apiArgs.DebitAccHash
      delete apiArgs.DebitChosenAccNo
      delete apiArgs.DebitAccBalance
      delete apiArgs.CreditAccNo
      delete apiArgs.CreditTitleUNI
      delete apiArgs.CreditAccHash
      delete apiArgs.CreditChosenAccNo
      delete apiArgs.CreditAccBalance
      delete apiArgs.OpenAgain

      return Order.add(apiArgs)
    })
    .then(() => {
      ownProps.closeModal()

      if (ownProps.onOrderAddEdit) ownProps.onOrderAddEdit()

      dispatch(destroyFetcher(ownProps.checkDebitAccountFetcherName))
      dispatch(destroyFetcher(ownProps.getDebitAccountBalanceFetcherName))
      dispatch(destroyFetcher(ownProps.checkCreditAccountFetcherName))
      dispatch(destroyFetcher(ownProps.getCreditAccountBalanceFetcherName))

      // only required for add order modal
      // so it's okay to static type MODAL_NAME
      if (values.OpenAgain) {
        dispatch(LKModalActions.open({ name: ownProps.name }))
      }
    })
    .catch(({ Error }) => dispatch(LKModalActions.openInfo(translateLKMessage(Error.Message || Error.Text))))
}
